<template>
  <main :class="$style.view" v-if="page.fields" ref="artist">
    <div :class="classes.wrapper">
      <div :class="$style.slider">
        <image-slider
          :media="page.fields.work_images"
          :subtitle="page.fields.subtitle"
        />
      </div>
      <transition name="t-bio">
        <repeater-matrix
          v-if="bioVisible"
          :items="page.fields.content"
          :class="$style.content"
        />
      </transition>
    </div>
  </main>
</template>

<script>
import PageService from '@/services/page'
import ImageSlider from '@/components/image-slider'
import RepeaterMatrix from '@/components/repeater-matrix'
import { mapState } from 'vuex'
import EventBus from '@/event-bus'

export default {
  name: 'Artist',
  components: {
    ImageSlider,
    RepeaterMatrix
  },
  metaInfo() {
    return {
      title: this.page.fields ? this.page.fields.title : ''
    }
  },
  data() {
    return {
      page: {}
    }
  },
  computed: {
    ...mapState(['bioVisible']),
    classes() {
      return {
        wrapper: [
          this.$style.wrapper,
          this.bioVisible ? this.$style['bio-visible'] : ''
        ]
      }
    }
  },
  methods: {
    closeBio() {
      this.$nextTick(() => {
        this.$scrollTo(this.$refs.artist, 350, {
          onDone: this.onScrollEnd
        })
      })

      // if (!window.onscroll) {
      //   // only execute this when user wasn't scrolling
      //   this.$store.commit('bioVisibility', {
      //     bioVisible: false
      //   })
      // }
    },
    onScrollEnd() {
      this.$store.commit('bioVisibility', {
        bioVisible: false
      })
    }
  },
  async created() {
    this.page = await PageService.get({ id: this.$route.name })
  },
  mounted() {
    EventBus.$on('close-bio', () => {
      this.closeBio()
    })
  },
  // activated() {
  //   EventBus.$on('close-bio', () => {
  //     this.closeBio()
  //   })
  // },
  deactivated() {
    this.$store.commit('bioVisibility', {
      bioVisible: false
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$store.dispatch('setTransitionName', {
      transition: 't-fade'
    })
    next()
  }
}
</script>

<style lang="scss" scoped>
.t-bio-enter-active,
.t-bio-leave-active {
  transition: opacity var(--medium) ease var(--xxlong);
}

.t-bio-enter-active {
  transition-delay: var(--xxlong);
}

.t-bio-enter,
.t-bio-leave-to {
  opacity: 0;
}
</style>

<style lang="scss" module>
.view,
.wrapper,
.slider {
  height: 100%;
}

.slider {
  transition: height var(--xxlong) ease;

  .bio-visible & {
    height: 70%;
  }
}

.content {
  @extend %text-width;

  padding-right: var(--gutter);
  padding-bottom: var(--blank-line);
  padding-left: var(--gutter);
}
</style>
